<div class="layout-column custom-panel full-width full-height">
  <div class="flex layout-column padding-10">

    <div class="layout-row layout-align-start-center pointer"
         appBringozIdGenerator="services-sort-packages-amount"
         (click)="onToggleSortTypeChange('packagesAmount' , sortBy === 'packagesAmount' && sortByType === 'desc' ? 'asc' : 'desc')">
      <span class="flex br-body-2 font-weight-400 gray-100" translate>Packages</span>
      <bringoz-icon *ngIf="sortBy === 'packagesAmount' && sortByType === 'desc'" iconName="arrow-down"
                    class="gray-100"></bringoz-icon>
      <bringoz-icon *ngIf="sortBy === 'packagesAmount' && sortByType === 'asc'" iconName="arrow-up"
                    class="gray-100"></bringoz-icon>
    </div>

    <div class="layout-row layout-align-start-center pointer margin-top-10"
         appBringozIdGenerator="services-sort-packages-weight"
         (click)="onToggleSortTypeChange('packagesWeight' , sortBy === 'packagesWeight' && sortByType === 'desc' ? 'asc' : 'desc')">
      <span class="flex br-body-2 font-weight-400 gray-100" translate>Weight</span>
      <bringoz-icon *ngIf="sortBy === 'packagesWeight' && sortByType === 'desc'" iconName="arrow-down"
                    class="gray-100"></bringoz-icon>
      <bringoz-icon *ngIf="sortBy === 'packagesWeight' && sortByType === 'asc'" iconName="arrow-up"
                    class="gray-100"></bringoz-icon>
    </div>


    <div class="layout-row layout-align-start-center pointer margin-top-10"
         appBringozIdGenerator="services-sort-packages-volume"
         (click)="onToggleSortTypeChange('packagesVolume' , sortBy === 'packagesVolume' && sortByType === 'desc' ? 'asc' : 'desc')">
      <span class="flex br-body-2 font-weight-400 gray-100" translate>Volume</span>
      <bringoz-icon *ngIf="sortBy === 'packagesVolume' && sortByType === 'desc'" iconName="arrow-down"
                    class="gray-100"></bringoz-icon>
      <bringoz-icon *ngIf="sortBy === 'packagesVolume' && sortByType === 'asc'" iconName="arrow-up"
                    class="gray-100"></bringoz-icon>
    </div>

    <div class="layout-row layout-align-start-center pointer margin-top-10"
         appBringozIdGenerator="services-sort-packages-pallets"
         (click)="onToggleSortTypeChange('packagesPallets' , sortBy === 'packagesPallets' && sortByType === 'desc' ? 'asc' : 'desc')">
      <span class="flex br-body-2 font-weight-400 gray-100" translate>Pallets</span>
      <bringoz-icon *ngIf="sortBy === 'packagesPallets' && sortByType === 'desc'" iconName="arrow-down"
                    class="gray-100"></bringoz-icon>
      <bringoz-icon *ngIf="sortBy === 'packagesPallets' && sortByType === 'asc'" iconName="arrow-up"
                    class="gray-100"></bringoz-icon>
    </div>


    <div class="layout-row layout-align-start-center pointer margin-top-10"
         appBringozIdGenerator="services-sort-spots-amount"
         (click)="onToggleSortTypeChange('spotsAmount' , sortBy === 'spotsAmount' && sortByType === 'desc' ? 'asc' : 'desc')">
      <span class="flex br-body-2 font-weight-400 gray-100" translate>Spots</span>
      <bringoz-icon *ngIf="sortBy === 'spotsAmount' && sortByType === 'desc'" iconName="arrow-down"
                    class="gray-100"></bringoz-icon>
      <bringoz-icon *ngIf="sortBy === 'spotsAmount' && sortByType === 'asc'" iconName="arrow-up"
                    class="gray-100"></bringoz-icon>
    </div>

    <div class="layout-row layout-align-start-center pointer margin-top-10"
         appBringozIdGenerator="services-sort-income"
         (click)="onToggleSortTypeChange('income' , sortBy === 'income' && sortByType === 'desc' ? 'asc' : 'desc')">
      <span class="flex br-body-2 font-weight-400 gray-100" translate>Income</span>
      <bringoz-icon *ngIf="sortBy === 'income' && sortByType === 'desc'" iconName="arrow-down"
                    class="gray-100"></bringoz-icon>
      <bringoz-icon *ngIf="sortBy === 'income' && sortByType === 'asc'" iconName="arrow-up"
                    class="gray-100"></bringoz-icon>
    </div>

    <div class="layout-row layout-align-start-center pointer margin-top-10"
         appBringozIdGenerator="services-sort-packages-value"
         (click)="onToggleSortTypeChange('packagesValue' , sortBy === 'packagesValue' && sortByType === 'desc' ? 'asc' : 'desc')">
      <span class="flex br-body-2 font-weight-400 gray-100" translate>Value</span>
      <bringoz-icon *ngIf="sortBy === 'packagesValue' && sortByType === 'desc'" iconName="arrow-down"
                    class="gray-100"></bringoz-icon>
      <bringoz-icon *ngIf="sortBy === 'packagesValue' && sortByType === 'asc'" iconName="arrow-up"
                    class="gray-100"></bringoz-icon>
    </div>

    <div class="layout-row layout-align-start-center pointer margin-top-10"
         appBringozIdGenerator="services-sort-price"
         (click)="onToggleSortTypeChange('price' , sortBy === 'price' && sortByType === 'desc' ? 'asc' : 'desc')">
      <span class="flex br-body-2 font-weight-400 gray-100" translate>Price</span>
      <bringoz-icon *ngIf="sortBy === 'price' && sortByType === 'desc'" iconName="arrow-down"
                    class="gray-100"></bringoz-icon>
      <bringoz-icon *ngIf="sortBy === 'price' && sortByType === 'asc'" iconName="arrow-up"
                    class="gray-100"></bringoz-icon>
    </div>

    <div class="layout-row layout-align-start-center pointer margin-top-10"
         appBringozIdGenerator="services-sort-sla"
         (click)="onToggleSortTypeChange('sla' , sortBy === 'sla' && sortByType === 'desc' ? 'asc' : 'desc')">
      <span class="flex br-body-2 font-weight-400 gray-100" translate>Time Window</span>
      <bringoz-icon *ngIf="sortBy === 'sla' && sortByType === 'desc'" iconName="arrow-down"
                    class="gray-100"></bringoz-icon>
      <bringoz-icon *ngIf="sortBy === 'sla' && sortByType === 'asc'" iconName="arrow-up"
                    class="gray-100"></bringoz-icon>
    </div>

    <div class="layout-row layout-align-start-center pointer margin-top-10"
         appBringozIdGenerator="services-sort-city"
         (click)="onToggleSortTypeChange('city' , sortBy === 'city' && sortByType === 'desc' ? 'asc' : 'desc')">
      <span class="flex br-body-2 font-weight-400 gray-100" translate>City</span>
      <bringoz-icon *ngIf="sortBy === 'city' && sortByType === 'desc'" iconName="arrow-down"
                    class="gray-100"></bringoz-icon>
      <bringoz-icon *ngIf="sortBy === 'city' && sortByType === 'asc'" iconName="arrow-up"
                    class="gray-100"></bringoz-icon>
    </div>

    <div class="layout-row layout-align-start-center pointer margin-top-10"
         appBringozIdGenerator="services-sort-address-quality"
         (click)="onToggleSortTypeChange('addressQuality' , sortBy === 'addressQuality' && sortByType === 'desc' ? 'asc' : 'desc')">
      <span class="flex br-body-2 font-weight-400 gray-100" translate>Address Quality</span>
      <bringoz-icon *ngIf="sortBy === 'addressQuality' && sortByType === 'desc'" iconName="arrow-down"
                    class="gray-100"></bringoz-icon>
      <bringoz-icon *ngIf="sortBy === 'addressQuality' && sortByType === 'asc'" iconName="arrow-up"
                    class="gray-100"></bringoz-icon>
    </div>

    <div class="layout-row layout-align-start-center pointer margin-top-10"
         appBringozIdGenerator="services-sort-synced"
         (click)="onToggleSortTypeChange('lastSyncedFromStepAt' , sortBy === 'lastSyncedFromStepAt' && sortByType === 'desc' ? 'asc' : 'desc')">
      <span class="flex br-body-2 font-weight-400 gray-100" translate>Synced</span>
      <bringoz-icon *ngIf="sortBy === 'lastSyncedFromStepAt' && sortByType === 'desc'" iconName="arrow-down"
                    class="gray-100"></bringoz-icon>
      <bringoz-icon *ngIf="sortBy === 'lastSyncedFromStepAt' && sortByType === 'asc'" iconName="arrow-up"
                    class="gray-100"></bringoz-icon>
    </div>


  </div>
</div>
